{
  "base": "Reporting",
  "segment": {
    "budget": "Budget and auditor confirmation",
    "funds": "Allocated funds",
    "administration": "Implementation and administration",
    "esa": "ESA reporting",
    "declaration": "Self-declaration",
    "goals": "Target figures",
    "registration": "Registration",
    "timeline": "Status",
    "confirmation": "Receipt",
    "summary": "Summary",
    "feedback": "Feedback",
    "approved": "Approved target figures",
    "achieved": "Goal achievement",
    "companies": "Company level",
    "operator": "Operator level",
    "activities": "Activities",
    "edit": "Edit",
    "deadlines": "Deadlines"
  },
  "title": {
    "index": "Reporting",
    "budget": "Budget and auditor confirmation",
    "goals": "Target figures",
    "goalsYear": "Target figures {{year}}",
    "achieved": "Goal achievement",
    "achievedYear": "Goal achievement {{year}}",
    "funds": "Allocation and use of funds",
    "fundsYear": "Allocated funds {{year}}",
    "administrationYear": "Implementation and administration {{year}}",
    "declaration": "Self-declaration",
    "declarationYear": "Self-declaration {{year}}",
    "deadlines": "Siva deadlines",
    "confirmation": "Submitted",
    "feedback": "Summary",
    "esa": "ESA reporting",
    "esaYear": "ESA reporting {{year}}"
  },
  "lead": {
    "funds": "Overview of implementation and administration and use of ESA reporting (article 28)"
  },
  "goals": {
    "introSections": "Target figures for {{year}} consist of the following sections:",
    "introQuestionCount": "There are {{questionCount}} questions in total and all of them must be answered. We recommend adding a comment if the figure needs an explanation.",
    "introDeadline": "The final deadline is 1 December {{year}}",
    "introShow": "Show target figures {{year}}",
    "confirmationSubmittedAt": "Target figures {{year}} were submitted {{date}}",
    "confirmationSupport": "For technical questions, email flerbedriftsportal@innovasjonnorge.no",
    "confirmationViewGoals": "View target figures {{year}}",
    "closedForReporting": "Target figures cannot be entered for {{year}} because the reporting year is closed.",
    "noGoalsFound": "No goals found for {{year}}.",
    "lastSaved": "Last saved {{timestamp}}",
    "sections": "Sections",
    "autoSaveNotice": "The form is saved as you go.",
    "categoryIntro": "All figures and percentages apply to {{year}} and are mandatory. We recommend adding comments to explain the target figures, especially if they differ a lot from last year.",
    "summaryHeading": "Summary",
    "showDescription": "Show description",
    "commentOptional": "Comment (optional)",
    "previousYearValue": "Target figure from {{year}}: {{value}}",
    "editGoal": "Edit target figure {{name}}",
    "sivaComment": "Comment from Siva",
    "originalValue": "Original target figure",
    "updateError": "Could not update the target figure",
    "loadError": "Could not load the target figures",
    "submitError": "Could not submit the target figures",
    "submitUpdatedError": "Could not submit the updated target figures",
    "noFeedbackTitle": "Sorry, something went wrong.",
    "noFeedbackBody": "No feedback has been registered on any target figures. You can only update target figures you have received feedback on. Submit so that Siva can add feedback.",
    "status": {
      "saved": "Saved",
      "savedBody": "Target figures {{year}} were saved {{timestamp}}",
      "savedLink": "Edit target figures {{year}}",
      "submitted": "Sent to Siva",
      "submittedBody": "Target figures {{year}} were sent to Siva and can no longer be changed",
      "feedback": "Feedback from Siva",
      "feedbackBody": "After reviewing the target figures, Siva has given feedback on target figures {{year}}",
      "feedbackLink": "View feedback from Siva",
      "approved": "Approved",
      "approvedBody": "Target figures {{year}} have been approved by Siva",
      "viewGoals": "View target figures {{year}}"
    }
  },
  "achieved": {
    "total": "Total goal achievement",
    "downloadReport": "Download summary report",
    "updateAllGoals": "Update all goals",
    "editAchievement": "Edit goal achievement",
    "levels": "Level",
    "viewDetails": "Show details",
    "valueLabel": "Value",
    "value": "Value: {{value}}",
    "goalValue": "Target figure: {{value}}",
    "ofTotal": "of {{total}}",
    "progressLabel": "{{name}}: {{value}} of {{expected}}",
    "autoSaved": "The changes were saved automatically at {{time}}",
    "endEditing": "Stop editing",
    "goalForYear": "Target figure {{year}}: {{value}}",
    "editedConfirmation": "The goal achievement has been edited.",
    "srlDescription": "State which SRL level the company is at as of 31 December (or when the company left the programme during the year). Click the orange question mark to see a description of the nine steps on the SRL scale.",
    "euDescriptionScope": "Register whether the company contributes a significant or potentially significant positive effect on one or more of the 6 environmental objectives in the EU taxonomy. Also register whether the company causes significant or potentially significant harm to any of the same objectives (following the “Do no significant harm” principle). If the company contributes neither significant positive nor negative effects, tick “None”. If you are in doubt whether the company contributes significant positive or negative effects, tick “none”.",
    "euDescriptionHelp": "Click the orange question mark to see a description of the six environmental objectives, and what is required to contribute a (potentially) significant positive or negative environmental effect.",
    "euDescriptionCalculation": "The target figure is given as the share of companies with a (potentially) significant positive contribution to at least one of the objectives. The criterion for (potentially) significant harm does not affect the goal achievement calculation."
  },
  "funds": {
    "tableCaption": "Allocated funds {{year}}",
    "article28": "Article 28",
    "preIncubation": "Pre-incubation",
    "otherPhases": "Other phases",
    "administration": "Implementation and administration",
    "totalAllocated": "Total allocated funds {{year}}"
  },
  "deadline": {
    "finishAnnualReporting": {
      "title": "Complete the annual reporting",
      "description": "All reporting for the previous year must be completed in Flerbedriftsportalen"
    },
    "uploadGoals": {
      "title": "Upload target figures",
      "description": "Upload target figures for the current year in Flerbedriftsportalen"
    },
    "regionalReporting": {
      "title": "Submit the regional reporting",
      "description": "The regional reporting form must be filled in and sent to Innovation Norway"
    },
    "uploadAuditorConfirmation": {
      "title": "Upload the auditor confirmation",
      "description": "Upload the auditor confirmation of total costs spent on implementation and administration related to last year's programme activity (not state aid). Use the template from Innovation Norway"
    },
    "ktuUpdate": {
      "title": "KTU update: Register new admissions and exits",
      "description": "Update Flerbedriftsportalen with new admissions and companies that have left"
    },
    "reportArticle28FirstHalf": {
      "title": "Report innovation aid (article 28) for the first half-year",
      "description": "Reporting of innovation aid (article 28) used in the first half-year"
    },
    "uploadBudget": {
      "title": "Upload the budget for next year",
      "description": "Upload the budget for implementation and administration for next year. Use the template from Innovation Norway"
    },
    "registerActiveCompanies": {
      "title": "Final deadline for registering all companies active this year",
      "description": "All companies that are or have been active during the year must be registered in Flerbedriftsportalen"
    }
  },
  "invalidYear": "Invalid year",
  "selectYear": "Select year"
}
